
const CryptoJS = require('crypto-js');
export function Encrypt(word) {
	// 加密秘钥 16位
	const key = CryptoJS.enc.Utf8.parse("8888888888888888");
	// 加密矢量
	const iv = CryptoJS.enc.Utf8.parse("6666666666666666");
	let encrypted = '';
	// 加密模式为CBC，补码方式为PKCS5Padding（也就是PKCS7）
	if (typeof (word) == 'string') {
		let srcs = CryptoJS.enc.Utf8.parse(word);
		encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 });
	}
	else if (typeof (word) == 'object') {
		//对象格式的转成json字符串
		let data = JSON.stringify(word);
		let srcs = CryptoJS.enc.Utf8.parse(data);
		encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
	}
	//返回base64
	//  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
	return encrypted.ciphertext.toString();
}

export function Decrypt(data) {

	data = CryptoJS.enc.Hex.parse(data);
	data = CryptoJS.enc.Base64.stringify(data);
	let key = CryptoJS.enc.Utf8.parse("8888888888888888");
	// 加密秘钥
	let iv = CryptoJS.enc.Utf8.parse("6666666666666666");
	// 矢量
	let baseResult = CryptoJS.enc.Base64.parse(data);
	// Base64解密 
	let ciphertext = CryptoJS.enc.Base64.stringify(baseResult);
	// Base64解密
	let decryptResult = CryptoJS.AES.decrypt(ciphertext, key, {
		// AES解密
		iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7
	});
	// 第一种  let resData=decryptResult.toString(CryptoJS.enc.Utf8).toString(); return JSON.parse(resData);
	// 第二种
	return CryptoJS.enc.Utf8.stringify(decryptResult)
}
export function Base64(str) {
	var str1 = CryptoJS.enc.Utf8.parse(str);
	var base64 = CryptoJS.enc.Base64.stringify(str1);
	return base64;
}